module.exports = __webpack_public_path__ + "static/media/1-4.d17c66a1.jpg";